import "./ChannelSelection.scss";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";

export default {
  name: "ChannelSelection",
  methods: {
    getPicturesWithChannel(channelValue) {
      const pictures = this.editedItem?.pictures;
      if (!channelValue || !Array.isArray(pictures)) {
        return [];
      }
      return pictures.filter(picture => {
        return (
          Array.isArray(picture?.channels) &&
          picture.channels.includes(channelValue)
        );
      });
    },
    getPicturesWithoutChannel(channelValue) {
      const pictures = this.editedItem?.pictures;
      if (!channelValue || !Array.isArray(pictures)) {
        return [];
      }
      return pictures.filter(picture => {
        return (
          Array.isArray(picture?.channels) &&
          !picture.channels.includes(channelValue)
        );
      });
    },
    getChannelTitle(channelValue) {
      return (
        this.channels?.find(channel => channel.value === channelValue)?.title ??
        channelValue
      );
    },
    removeChannelFromPictures(channelValue) {
      this.getPicturesWithChannel(channelValue).forEach(picture => {
        if (
          !Array.isArray(picture?.channels) ||
          !picture.channels.includes(channelValue)
        ) {
          return;
        }
        picture.channels = picture.channels.filter(channel => {
          return channel !== channelValue;
        });
        picture.channels.reverse().reverse();
      });
    },
    addChannelToPictures(channelValue) {
      this.getPicturesWithoutChannel(channelValue).forEach(picture => {
        if (!Array.isArray(picture?.channels)) {
          picture.channels = [];
        }
        picture.channels.push(channelValue);
      });
    },
    //remove or add publication-channel
    async toggleChannel(channelValue) {
      if (this.readOnly) {
        return;
      }
      if (!this.cOwnChannels.includes(channelValue)) {
        return;
      }
      if (this.editedItem.channels.includes(channelValue)) {
        this.editedItem.channels = this.editedItem.channels.filter(item => {
          return item !== channelValue;
        });
        this.removeChannelFromPictures(channelValue);
        this.editedItem.channels.reverse().reverse();
      } else {
        this.editedItem.channels.push(channelValue);
        this.addChannelToPictures(channelValue);
        this.setChannelDescriptions(channelValue);
      }
      this.$emit("saveChannels");
    },
    setChannelDescriptions(channelValue) {
      if (
        channelValue &&
        this.editedItem &&
        this.editedItem?.alternative_content
      ) {
        this.editedItem.alternative_content[channelValue] = {
          description: "",
          short_description: ""
        };
        this.$store.state.momentsForEvent?.forEach(moment => {
          const keys = Object.keys(moment.alternative_content);
          const missingChannelDescription = this.editedItem.channels.filter(
            ch => !keys.includes(ch)
          );
          if (missingChannelDescription.length) {
            missingChannelDescription.forEach(channel => {
              moment.alternative_content[channel] = {
                description: "",
                short_description: ""
              };
            });
          }
        });
      }
    }
  },
  computed: {
    cOwnChannels() {
      let channels = this.ownChannels;
      if (!channels?.length) {
        channels = [...this.channels];
      }
      return channels.map(channel => channel.value);
    }
  },
  props: {
    editedItem: {},
    channels: {
      type: Array
    },
    ownChannels: {
      type: Array
    },
    iconView: { type: Boolean },
    size: { default: 16 },
    readOnly: { type: Boolean },
    event: "saveChannels"
  }
};
